import * as ko from 'knockout'
import ObservableScratching from '../../../Model/Observables/ObservableScratching'
import { ScratchingsViewModel } from './ScratchingsViewModel'
import template from './scratchings.tpl.html'

interface Params {
  availableScratchings: ko.ObservableArray<ObservableScratching>
}

if (!ko.components.isRegistered('scratchings-panel')) {
  ko.components.register('scratchings-panel', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new ScratchingsViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
